import React from 'react'
import DocumentTypes from "./DocumentTypes";
import DatePicker from "react-date-picker";
import Grades from "./Grades";
import {DegreesFunColQuery} from "../apollo/queries/DegreesQuery";
import InscriptionInput from "./InscriptionInput";
import {Query} from "react-apollo";
import {EmployeeQuery} from "../apollo/queries/FunColEmployeeQuery";
import Spinner from "react-bootstrap/Spinner";
import CiberAlerts, {MESSAGES} from "../util/Messages";
import {InscriptionFunColMutation} from "../apollo/mutations/InscriptionMutation";
import {Mutation} from "@apollo/react-components";
import ModalDateCorrection from "./ModalDateCorrection";
import FinalStep from "./FinalStep";
import {calculateAge} from "../util/Utils";

export default class InscriptionFormFunCol extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      documentType: {value: ''},
      document: '',
      name: '',
      lastName: '',
      toInscription: true,
      documentTypeAspirant: {value: ''},
      documentAspirant: '',
      nameAspirant: '',
      lastNameAspirant: '',
      birthDateAspirant: '',
      contactPhone: '',
      age: '',
      contactName: '',
      ageAspirant: '',
      grade: {
        value: {
          levelId: '',
          programId: '',
          degreeId: '',
        }
      },
      validatedWorker: false,
      errorMessage: null,
      validationCollector:[]

    }
  }

  handleChange = (e, label) => {
    if (label) {
      this.setState({
        [label]: e
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
    }
  };

  onChangeBirthDate = (date) => {
    this.setState({
      birthDateAspirant: date,
      ageAspirant: calculateAge(date)
    });
  };

  enableForm = () => {
    this.setState({
      validatedWorker: true
    })
  }

  closeModal = () => {
    this.setState({
      showModal: false
    })
  };

  openModal = () => {
    this.setState({
      showModal: true
    })
  };

  readyToSend = () => {
    return this.state.documentType.value && this.state.documentAspirant.value && this.state.grade.value.levelId
      && this.state.birthDateAspirant && this.state.nameAspirant && this.state.lastNameAspirant
  }


  collectValidations = (field, isValid) => {
    this.setState({
      validationCollector: this.state.validationCollector.filter(function (fieldList) {
        return fieldList !== field
      })
    }, () => {
      if (!isValid) {
        this.setState(prevState => ({
          validationCollector: [...prevState.validationCollector, field]
        }))
      }
    });
  }


  render() {
    return (
      <Mutation mutation={InscriptionFunColMutation}
        variables={this.state.toInscription ? {
          dataInscription: {
            affiliateDocType: this.state.documentType.value,
            affiliateDocument: this.state.document,
            beneficiaryDocType: this.state.documentTypeAspirant.value,
            beneficiaryDocument: this.state.documentAspirant,
            levelId: this.state.grade.value.levelId,
            programId: this.state.grade.value.programId,
            degreeId: this.state.grade.value.degreeId,
            birthDate: this.state.birthDateAspirant,
            beneficiaryName: this.state.nameAspirant,
            beneficiaryLastName: this.state.lastNameAspirant,
            deviceId: "AFC" + Math.floor(Math.random() * ((999 - 100) + 1))
          }
        } : {
          dataInscription: {
            affiliateDocType: this.state.documentType.value,
            affiliateDocument: this.state.document,
            beneficiaryDocType: this.state.documentTypeAspirant.value,
            beneficiaryDocument: this.state.documentAspirant,
            birthDate: this.state.birthDateAspirant,
            contact: this.state.contactName,
            phoneContact: this.state.contactPhone,
            beneficiaryName: this.state.nameAspirant,
            beneficiaryLastName: this.state.lastNameAspirant,
            deviceId: "AFC" + Math.floor(Math.random() * ((999 - 100) + 1))
          }
        }}
        onError={(error) => {
          this.setState({
            errorMessage: error
          })
        }}>
        {(confirmInscription, result) => {
          const {data, loadingSend} = result;

          const confirmDate = () => {
            this.closeModal();
            this.setState({
              errorMessage: '',
              toInscription: false
            }, () => {
              return confirmInscription()
            });

          };

          if (data && data.saveInscriptionFunCol && data.saveInscriptionFunCol.statusCode === "CIB-GEN-0200") {
            if (data.saveInscriptionFunCol.redirectUrl) {
              window.location.replace(data.saveInscriptionFunCol.redirectUrl)
            } else {
              return <FinalStep message={MESSAGES["SUCCESS_FUNCOL"]} title="Pre-Inscripción Colegio Fundación Colombia"/>
            }
          }

          return (<>
            <div className="card card-signin my-5 col-sm-6 border-left-0">
              <div className="card-body">
                <h1 className="card-title text-center">Pre-Inscripción Colegio Fundación Colombia</h1>
                {this.state.errorMessage ?
                  <CiberAlerts error={this.state.errorMessage} callBack={this.openModal}/> :
                  null
                }
                <DocumentTypes handleChange={this.handleChange} documentType={this.state.documentType}
                  label="Tipo de Documento Trabajador" name="documentType"/>
                <InscriptionInput name="document" value={this.state.document} label="Número de Documento Trabajador"
                  handleChange={this.handleChange} handleBlur={this.enableForm} validation="number" collectValidations={this.collectValidations}/>
                {this.state.validatedWorker ?
                  <Query query={EmployeeQuery} fetchPolicy={"network-only"}
                    variables={{
                      documentType: this.state.documentType.value,
                      documentNumber: this.state.document
                    }}
                    onCompleted={data => {
                      this.setState({
                        errorMessage: null,
                        validatedWorker: true,
                        name: data.employeeFunCol.name,
                        lastName: data.employeeFunCol.lastName
                      })
                    }}
                    onError={error => {
                      this.setState({
                        validatedWorker: false,
                        errorMessage: error
                      })
                    }}
                  >
                    {({loading, error, data}) => {
                      return (
                        <>

                          {loading ? <Spinner animation="border" role="status">
                              <span className="sr-only">Loading...</span>
                            </Spinner> :
                            <>
                              <InscriptionInput name="name" value={this.state.name} label="Nombre Trabajador"
                                handleChange={this.handleChange} readOnly={true}/>
                              <InscriptionInput name="lastName" value={this.state.lastName} label="Apellido Trabajador"
                                handleChange={this.handleChange} readOnly={true}/>
                              <DocumentTypes handleChange={this.handleChange}
                                documentType={this.state.documentTypeAspirant}
                                label="Tipo de Documento Aspirante" name="documentTypeAspirant"/>
                              <InscriptionInput name="documentAspirant" value={this.state.documentAspirant}
                                label="Número de Documento Aspirante" handleChange={this.handleChange} validation="number" collectValidations={this.collectValidations}/>



                              <InscriptionInput name="nameAspirant" value={this.state.nameAspirant}
                                label="Nombre Aspirante"
                                handleChange={this.handleChange}/>
                              <InscriptionInput name="lastNameAspirant" value={this.state.lastNameAspirant}
                                label="Apellido del Aspirante"
                                handleChange={this.handleChange}/>
                              <label>Fecha de Nacimiento</label>
                              <br/>
                              <DatePicker onChange={this.onChangeBirthDate} value={this.state.birthDateAspirant}
                                maxDate={new Date()}/>
                              <br/>
                              <InscriptionInput value={this.state.ageAspirant} label="Edad" readOnly={true}/>
                              <Grades grade={this.state.grade} service={DegreesFunColQuery} variables={{}}
                                index="degreesFunCol"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      handleChange={this.handleChange}/>
                              <br/>
                              <button className="btn btn-lg btn-primary btn-block" type="button"
                                disabled={!(this.state.documentType.value && this.state.documentTypeAspirant.value && this.state.documentAspirant && this.state.grade.value.levelId
                                  && this.state.birthDateAspirant && this.state.nameAspirant && this.state.lastNameAspirant)}
                                onClick={confirmInscription}>
                                Diligenciar Inscripción  {loadingSend ? <Spinner animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                              </Spinner> : ""}
                              </button>
                              <ModalDateCorrection
                                show={this.state.showModal}
                                handleClose={this.closeModal}
                                withContactInfo={true}
                                date={this.state.birthDateAspirant}
                                contactName={this.state.contactName}
                                contactPhone={this.state.contactPhone}
                                onChange={this.onChangeBirthDate}
                                callBack={confirmDate}
                                onChangeContact={this.handleChange}

                              />
                            </>}
                        </>
                      )
                    }}
                  </Query> : ""
                }
              </div>
            </div>
          </>)
        }}
      </Mutation>
    )
  }

}
